function scrollTrigger (selector, options = {}) {
  let els = document.querySelectorAll(selector)
  els = Array.from(els)
  els.forEach(el => {
    const animationName = el.getAttribute('data-animation-name') || 'fadeIn'
    const speed = el.getAttribute('data-animation-duration') // e.g. '0.5s'
    const delay = el.getAttribute('data-animation-delay') // in seconds
    if (speed) { setStyle(el, 'animation-duration:' + speed) }
    if (delay) { setStyle(el, 'animation-delay:' + delay) }
    el.classList.add(animationName)
    addObserver(el, options)
  })
}

function addObserver (el, options) {
  if (!('IntersectionObserver' in window)) {
    if (options.cb) {
      options.cb(el)
    } else {
      entry.target.classList.add('animated')
    }
    return
  }
  const observer = new IntersectionObserver((entries, observer) => { // this takes a callback function which receives two arguments: the elemts list and the observer instance
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        if (options.cb) {
          options.cb(el)
        } else {
          entry.target.classList.add('animated')
        }
        observer.unobserve(entry.target)
      }
    })
  }, options)
  observer.observe(el)
}

function setStyle(el, css){
  el.setAttribute('style', el.getAttribute('style') + '; ' + css);
}

function updateBindings () {
  scrollTrigger('.animate', {
    rootMargin: '0px 0px -10% 0px',
    threshold: 0.1 // half of item height
  })
}

updateBindings()

// Check for new elements to rebind after sprig alters the DOM
if (global.htmx) {
  global.htmx.on('htmx:afterSwap', updateBindings)
}
